import { render, staticRenderFns } from "./SeparateClient.vue?vue&type=template&id=79b177fe&scoped=true&"
import script from "./SeparateClient.vue?vue&type=script&lang=js&"
export * from "./SeparateClient.vue?vue&type=script&lang=js&"
import style0 from "./SeparateClient.vue?vue&type=style&index=0&id=79b177fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b177fe",
  null
  
)

export default component.exports